import axios from "@/api/axiosInstance";
import { FetchAccountsByAccountIdsResponse } from "./types";

export const fetchAccountsByAccountIds = async (
  corporationName: string,
  accountIds: string[],
): Promise<FetchAccountsByAccountIdsResponse> => {
  const response = await axios.get<FetchAccountsByAccountIdsResponse>(
    `/api/private/corporation/${corporationName}/accounts/id/${accountIds.join(",")}`,
  );
  return response.data;
};
